<template>
  <b-modal v-model="isShow"
           centered
           :size="size"
           :title="title"
           :no-close-on-backdrop="noCloseOnBackdrop"
           :modal-footer="false">
    <component v-if="isShow"
               :is="currentModalComponent"
               v-on="childListeners"
               @closeModal="closeModal"
               :params="params"
               :size="size"/>
  </b-modal>
</template>

<script>
import modals from './list'

export default {
  name: "ModalWrapper",
  props: {
    value: {
      type: Boolean,
      default: false
    },
    name: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    params: {
      type: Object,
      default: () => {}
    },
    size: {
      type: String,
      required: false,
      default: 'md'
    },
    noCloseOnBackdrop: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    currentModalComponent() { return modals.get(this.name) },
    /**
     * Все обработчики со страницы уходят в саму модалку.
     *
     * Раньше обёртка пробрасывала ровно три события — submit, generate и
     * closeModal, — а любое своё событие модалки терялось по дороге. Из-за
     * этого не работал @giveawayDeleted в ListGiveaways: список не
     * перезагружался после удаления розыгрыша. Тем же были сломаны
     * @voteDeleted в ListVotes и @close на страницах WowStreamers —
     * обработчики написаны, но не вызывались никогда.
     *
     * input исключён намеренно: это событие v-model самой обёртки, отдавать
     * его внутрь нельзя — модалка смогла бы переписать своё состояние показа.
     */
    childListeners() {
      const listeners = { ...this.$listeners }
      delete listeners.input
      return listeners
    },
    isShow: {
      get: function () { return this.value },
      set: function (newValue) { this.$emit('input', newValue) }
    }
  },
  methods: {
    closeModal() {
      this.isShow = false
    }
  }
}
</script>

<style scoped lang="scss">
::v-deep {
  .modal-footer {
    display: none !important;
  }
}
</style>